import React, {lazy} from 'react';
import {Route, IndexRoute} from 'react-router';

const ReportsPage = lazy(() => import(/* webpackChunkName: "Reports" */ './ReportsPage'));

export default (
  <Route path='/reports'>
    <IndexRoute component={ReportsPage} />
    <Route path='*' component={ReportsPage} />
  </Route>
);
